import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import Tooltip from "@material-ui/core/Tooltip";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";

import { withStyles, Typography } from "@material-ui/core";
import ChevronRight from "@material-ui/icons/ChevronRight";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import { AccomplishmentPlan, AccomplishmentTimeline } from "../models";

import { createSelector } from "../../common/orm";
import HelpLabel from "../../common/HelpLabel";
import Checkbox from "../../common/Checkbox";
import EnhancedTableHead from "../../common/EnhancedTableHead";
import CustomTableCell from "../../common/TableCell";
import DatePicker from "../../common/DatePicker";
import TextField from "../../common/TextField";
import { getValue } from "../../../api/utils";

const getTimelines = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (session, id) => {
        return session.AccomplishmentTimeline.filter({ accomplishment: id }).orderBy("id").toModelArray();
    }
);

const styles = theme => ({
    rightAlign: {
        textAlign: "right"
    },
    button: {
        marginRight: theme.spacing(2)
    },
    table: {
        width: "100%",
        "& tbody tr:nth-child(even)": {
            backgroundColor: "#ffeff2"
        }
    },
    deleteWidth: {
        minWidth: 32,
        width: 32,
        height: 32,
        marginRight: 8,
    },
    centerAlign: {
        textAlign: "center"
    },
    nowrap: {
        whiteSpace: "nowrap"
    },
    checkbox: {
        border: "1px solid",
        padding: 10,
        paddingBottom: 0,
        "&:hover": {
            backgroundColor: "#eee"
        }
    }
});

class TimelineTab extends Component {
    componentDidMount() {
        const { handleUnsavedFields } = this.props;
        document.title = "Accomplishment Plan: Timeline - Lessard Sams Outdoor Heritage Council";
        this.props.onRef(this);
        const _this = this;
        // FIXME: react-forms calls formDidUpdate when (if) validation is ran right away
        // making it appear there is a edited field even if there isn't
        // Reset fields to false to not require validation when mounted
        setTimeout(function () {
            handleUnsavedFields(false);
            _this.props.appContainer.current.scrollTop();
        }, 1);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    applyOther = (value, element) => {
        const { ormAccomplishmentPlanUpdateLocalOnly } = this.props;
        const { id } = this.props.accomplishment_plan;
        ormAccomplishmentPlanUpdateLocalOnly({
            id: id,
            [element]: value
        });
        this.setState({ foo: "bar" });
    };

    updateAP(values, fromStepper) {
        const { ormAccomplishmentPlanUpdate, history, handleUnsavedFields, handleNext, accomplishment_plan } = this.props;
        const { id } = accomplishment_plan;

        if (Number.isInteger(fromStepper)) {
            values.activeStep = fromStepper;
        }
        values.federal_funds_confirmation_document = accomplishment_plan.federal_funds_confirmation_document;
        values.modify_date_label = accomplishment_plan.modify_date_label;
        values.signup_criteria = accomplishment_plan.signup_criteria;

        ormAccomplishmentPlanUpdate({
            id: id,
            ...values
        });

        handleUnsavedFields(false);

        if (!Number.isInteger(fromStepper)) {
            if (this.state.draftClick) {
                history.push("/dashboard/");
            } else {
                handleNext();
            }
        }
    }

    render() {
        const {
            classes,
            accomplishment_plan,
            handleUnsavedFields,
            timelines,
            ormAccomplishmentTimelineCreate,
            ormAccomplishmentTimelineDelete,
            ormAccomplishmentTimelineUpdate,
            settings,
            ActionMenu, authState
        } = this.props;
        var is_read_only = true;
        if ((authState && authState.user && authState.user.role === "admin") || (accomplishment_plan.status === "First Draft" || accomplishment_plan.status === "Approved First Draft" || accomplishment_plan.status === "Started Request for Amendment Change"))
            is_read_only = false;
        if (authState && authState.user && authState.user.role === "readonly")
            is_read_only = true;

        const showCheckbox = getValue(accomplishment_plan, "proposal_acknowledgement_timeline") === false;

        return (
            <Form
                getApi={el => (this.form = el)}
                key={accomplishment_plan.id}
                dontValidateOnMount={true}
                validateOnSubmit={true}
                defaultValues={accomplishment_plan.formData}
                formDidUpdate={() => handleUnsavedFields(true)}
                onSubmit={(values, fromStepper) => this.updateAP(values, fromStepper)}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={9} xl={7}>
                                <HelpLabel
                                    inputLabel="Timeline"
                                    title={true}
                                    showLabel={true}
                                    helpText={settings.timeline_tab_help}
                                />
                                {ActionMenu}
                            </Grid>
                            <Grid item xs={12} lg={9} xl={7}>
                                {showCheckbox && (
                                    <div className={classes.checkbox}>
                                        <Checkbox
                                            field="proposal_acknowledgement_timeline"
                                            eventHandle={this.applyOther}
                                            disabled={is_read_only}
                                            label="Please check this box to acknowledge that the information in this tab was brought over from your proposal and is still valid."
                                        />
                                    </div>
                                )}
                            </Grid>
                            <Grid item xs={12} lg={9} xl={7}>
                                <Button disabled={is_read_only} variant="contained" color="primary" onClick={() => ormAccomplishmentTimelineCreate({ accomplishment: accomplishment_plan.id })}>
                                    <AddCircleIcon />
                                    &nbsp;&nbsp;&nbsp;Add New Activity
                                </Button>
                            </Grid>
                            <Grid item xs={12} lg={9} xl={7}>
                                <TimelineTable
                                    ormAccomplishmentTimelineUpdate={ormAccomplishmentTimelineUpdate}
                                    ormAccomplishmentTimelineDelete={ormAccomplishmentTimelineDelete}
                                    rows={timelines}
                                    is_read_only={is_read_only}
                                    classes={classes}
                                />
                            </Grid>
                            <Grid item xs={12} lg={9} xl={7}>
                                <DatePicker
                                    disabled={is_read_only}
                                    field="final_report_submission"
                                    label="Date of Final Report Submission"
                                />
                                <Typography>
                                    <i>
                                        Final reports are due October 1 after the availability of appropriation noted in law.
                                        The date for R/E activity should be the earlier date. If an extension is needed for a later acquired acquisition, 
                                        an amendment request should be submitted at that time.
                                    </i>
                                </Typography>
                            </Grid>
                            {settings["availability_" + accomplishment_plan.ml_year] && (
                                <Grid item xs={12} lg={9} xl={7}>
                                    <Typography variant="h3">Availability of Appropriation</Typography>
                                    <Typography>
                                        {settings["availability_" + accomplishment_plan.ml_year]}
                                    </Typography>
                                </Grid>
                            )}
                            <Grid item xs={12} className={classes.rightAlign} lg={9} xl={7}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={is_read_only}
                                    onClick={() => this.setState({ draftClick: true, submitClicked: true })}
                                    className={classes.button}>
                                    Save Draft and Return to Dashboard
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={is_read_only}
                                    color="primary"
                                    onClick={() => this.setState({ draftClick: false, submitClicked: true })}>
                                    Save and Proceed to Budget <ChevronRight />
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Form>
        );
    }
}

class TimelineTable extends Component {
    columnData = [
        { id: "activity", numeric: false, label: "Activity", allowSort: false },
        { id: "date", numeric: false, label: "Estimated Completion Date", allowSort: false },
        { id: "actions", numeric: false, label: "Actions", allowSort: false, width: "20px" },
    ];
    typingTimer = []

    updateTimeline = (value, element, id) => {
        const { ormAccomplishmentTimelineUpdate } = this.props;

        clearTimeout(this.typingTimer[element]);
        this.typingTimer[element] = setTimeout(function () {
            ormAccomplishmentTimelineUpdate({
                id: id,
                [element]: value,
            });
        }, 1000);
    }

    render() {
        const { rows, classes, ormAccomplishmentTimelineDelete, is_read_only } = this.props;

        return (
            <Table className={classes.table}>
                <EnhancedTableHead columnData={this.columnData} />
                <TableBody>
                    {rows.map(n => {
                        return (
                            <TableRow hover key={n.id}>
                                <CustomTableCell>
                                    <Form key={n.id + "activity"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    multiline
                                                    rows={1}
                                                    rowsMax={3}
                                                    // rows={n.activity ? Math.ceil(n.activity.length / 50) : 1}
                                                    tableFormat
                                                    eventHandle={(v, e) => this.updateTimeline(v, e, n.id)}
                                                    field="activity"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={n.id + "date"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    multiline
                                                    rows={1}
                                                    rowsMax={3}
                                                    tableFormat
                                                    eventHandle={(v, e) => this.updateTimeline(v, e, n.id)}
                                                    field="date"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell className={classes.nowrap}>
                                    <Tooltip title="Delete Timeline Activity">
                                        <Button
                                            color="primary"
                                            disabled={is_read_only}
                                            className={classes.deleteWidth}
                                            onClick={() => ormAccomplishmentTimelineDelete(n.id)}>
                                            <DeleteIcon color="primary" />
                                        </Button>
                                    </Tooltip>
                                </CustomTableCell>
                            </TableRow>
                        );
                    })}
                    {rows.length < 1 && (
                        <TableRow>
                            <CustomTableCell colSpan={3} className={classes.centerAlign}>
                                No Timeline Activities Found
                            </CustomTableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );
    }
}

TimelineTab = connect(
    (state, ownProps) => ({
        timelines: getTimelines(state, ownProps),
        authState: state.auth
    }),
    {
        ...AccomplishmentPlan.actions,
        ...AccomplishmentTimeline.actions
    }
)(TimelineTab);

export default withStyles(styles)(withRouter(TimelineTab));
